import { render } from "./AgentEditTicket.vue?vue&type=template&id=1f31def0&scoped=true"
import script from "./AgentEditTicket.vue?vue&type=script&lang=js"
export * from "./AgentEditTicket.vue?vue&type=script&lang=js"

import "./AgentEditTicket.vue?vue&type=style&index=0&id=1f31def0&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\Admin_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f31def0"]])

export default __exports__